import { trans } from '../localization';
import {
  NOW_TABLE_MQTT_TOPIC,
  RESTAURANT_MQTT_TOPIC,
} from './constants';

import MesLogoIcon from '../assets/common/static/icons/chat/mes-logo.png'
import TableLogoIcon from '../assets/common/static/icons/chat/table-logo.png'


export function findEnumById(type, id) {
  const result = Object.keys(type).filter(
    key => type[key].id === parseInt(id, 10),
  );
  if (result) {
    return type[result[0]];
  }
  return {};
}

export function genEnumToOption(type) {
  return Object.keys(type).map(item => ({
    value: type[item].value,
    label: trans(type[item].label),
  }));
}

export function transEnum(object) {
  return {
    ...object,
    label: trans(object.label),
  };
}

export const EnumPage = {
  REPORT_DISH: {
    id: 'REPORT_DISH',
  },
  REPORT_RESTAURANT: {
    id: 'REPORT_RESTAURANT',
  },
  ORDER_MANAGEMENT: {
    id: 'ORDER_MANAGEMENT',
  },
  NOW_SHIP_ORDER_MANAGEMENT: {
    id: 'NOW_SHIP_ORDER_MANAGEMENT',
  },
  NOW_SHIP_REPORT: {
    id: 'NOW_SHIP_REPORT',
  },
  WALLET_MANAGEMENT: {
    id: 'WALLET_MANAGEMENT',
  },
  TABLE_MANAGEMENT: {
    id: 'TABLE_MANAGEMENT',
  },
  NOW_PORTAL_TRANSACTION_HISTORY: {
    id: 'NOW_PORTAL_TRANSACTION_HISTORY',
  },
  EXPORT_RESTAURANT: {
    id: 'EXPORT_RESTAURANT',
  },
  SETTING_STAFF: {
    id: 'SETTING_STAFF',
  },
  SETTING: {
    id: 'SETTING',
  },
};

export const EnumLoginType = {
  PASSWORD: {
    id: 0,
    description: 'PASSWORD',
  },
  GOOGLE: {
    id: 2,
    description: 'GOOGLE',
  },
  ACCOUNT_KIT: {
    id: 3,
    description: 'OTP',
  },
};

export const EnumAppType = {
  NOW_MERCHANT_APP: 1001,
  NOW_TABLE_APP: 1012,
};

export const EnumClientType = {
  CLIENT_WEB: 1,
};

export const EnumPagingMode = {
  NONE: {
    id: 1,
  },
  SELF_PAGING: {
    id: 2,
  },
  PAGING_IDS: {
    id: 3,
  },
  PAGING_OFFSET_LIMIT: {
    id: 4,
  },
};

export const EnumOrderGroupStatus = {
  SCHEDULED: {
    id: 5,
    description: 'merchant_order_group_status_scheduled',
  },
  PROCESSING: {
    id: 1,
    description: 'merchant_order_group_status_processing',
  },
  CONFIRMED: {
    id: 4,
    description: 'merchant_order_group_status_confirm',
  },
  COMPLETED: {
    id: 2,
    description: 'merchant_order_group_status_completed',
  },
  CANCELLED: {
    id: 3,
    description: 'merchant_order_group_status_cancelled',
  },
};

export const EnumListOrderSortBy = {
  STATUS: {
    id: 1,
    description: 'STATUS',
  },
  DELIVERY_DATETIME: {
    id: 2,
    description: 'DELIVERY_DATETIME',
  },
  DELIVERY_DATETIME_DESC: {
    id: 6,
    description: 'DELIVERY_DATETIME_DESC',
  },
  SUBMIT_DATETIME: {
    id: 3,
    description: 'SUBMIT_DATETIME',
  },
  CANCEL_DATETIME: {
    id: 4,
    description: 'CANCEL_DATETIME',
  },
  PICK_TIME: {
    id: 5,
    description: 'PICK_TIME',
  },
  ORDER_CODE: {
    id: 7,
    description: 'ORDER_CODE',
  },
  ORDER_CODE_DESC: {
    id: 8,
    description: 'ORDER_CODE_DESC',
  },
  MERCHANT_PAID_AMOUNT: {
    id: 9,
    description: 'MERCHANT_PAID_AMOUNT',
  },
  MERCHANT_PAID_AMOUNT_DESC: {
    id: 10,
    description: 'MERCHANT_PAID_AMOUNT_DESC',
  },
  STATUS_DESC: {
    id: 11,
    description: 'STATUS_DESC',
  },
};

export const EnumOrderListFilter = {
  ALL: {
    id: 0,
    description: 'mod_order_list_filter_ALL',
  },
  INCLUDE_VAT: {
    id: 1,
    description: 'mod_order_list_filter_INCLUDE_VAT',
  },
  NOT_INCLUDE_VAT: {
    id: 2,
    description: 'mod_order_list_filter_NOT_INCLUDE_VAT',
  },
};

export const EnumOrderMerchantStatus = {
  PICKED: {
    id: 1,
    description: 'merchant_order_status_picked',
    class: 'order-picked',
    icon: 'icon icon-picked mr-1',
  },
  DELIVERED: {
    id: 2,
    description: 'merchant_order_status_delivered',
    class: 'order-picked',
    icon: 'fas fa-check mr-1',
  },
  CONFIRMED: {
    id: 3,
    description: 'merchant_order_status_confirmed',
    class: 'order-confirm',
    icon: 'fas fa-check mr-1',
  },
  M_CHANGED: {
    id: 4,
    description: 'merchant_order_status_m_changed',
    class: 'order-confirm',
    icon: 'fas fa-check mr-1',
  },
  M_ASSIGNED: {
    id: 5,
    description: 'merchant_order_status_m_assigned',
    class: 'order-timeout',
    icon: 'fas fa-check mr-1',
  },
  M_RECEIVED: {
    id: 6,
    description: 'merchant_order_status_m_received',
    class: 'order-timeout',
    icon: 'fas fa-check mr-1',
  },
  M_OUTOFSERVICE: {
    id: 7,
    description: 'merchant_order_status_m_out_of_service',
    class: 'order-cancel',
    icon: 'far fa-times-circle mr-1',
  },
  CANCELLED: {
    id: 8,
    description: 'merchant_order_status_m_cancelled',
    class: 'order-cancel',
    icon: 'far fa-times-circle mr-1',
  },
  M_TIMEOUT: {
    id: 9,
    description: 'merchant_order_status_m_timeout',
    class: 'order-timeout',
    icon: 'far fa-circle mr-1',
  },
  VERIFIED: {
    id: 10,
    description: 'merchant_order_status_verified',
    class: 'order-confirm',
    icon: 'fas fa-check mr-1',
  },
};

export const EnumOrderStatusBy = {
  DELIVERY_NOW: {
    id: 1,
    description: 'rebranding.merchant_order_status_by_delivery',
  },
  MERCHANT: {
    id: 2,
    description: 'merchant_order_status_by_merchant',
  },
};

export const EnumRejectOrderReason = {
  CHOOSE_OPTION: {
    id: 0,
    description: 'CHOOSE_OPTION',
    icon: '',
  },
  WRONG_MENU: {
    id: 1,
    description: 'mod_reject_out_of_stock_wrong_price',
    icon: 'icon-out-of-stock',
  },
  RESTAURANT_BUSY: {
    id: 2,
    description: 'mod_reject_busy_now',
    icon: 'icon-restaurant-busy',
  },
  RESTAURANT_CLOSES: {
    id: 3,
    description: 'mod_reject_closed_already',
    icon: 'icon-restaurant-close',
  },
  WRONG_COMMISSION: {
    id: 4,
    description: 'mod_reject_wrong_commission',
    icon: 'icon-error-commission',
  },
  CUSTOM: {
    id: 5,
    description: 'mod_reject_custom',
    icon: 'icon-error-custom',
  },
};

export const EnumOrderUpdateStatus = {
  CONFIRM: {
    id: 0,
    description: 'CONFIRM',
  },
  RECEIVED: {
    id: 1,
    description: 'RECEIVED',
  },
  OUT_OF_SERVICE: {
    id: 2,
    description: 'OUT_OF_SERVICE',
  },
  PICKED: {
    id: 3,
    description: 'PICKED',
  },
  DONE: {
    id: 4,
    description: 'DONE',
  },
  INPUT_TO_PRIVATE_SYSTEM: {
    id: 5,
    description: 'INPUT_TO_PRIVATE_SYSTEM',
  },
  CANCEL: {
    id: 6,
    description: 'CANCEL',
  },
};

export const EnumMerchantPaidMethod = {
  COD: {
    id: 1,
    description: 'merchant_paid_method_cod',
    icon: 'icon-money',
    title: 'mod_transaction_cod',
  },
  PAYNOW_CREDIT: {
    id: 2,
    description: 'merchant_paid_method_paynow_credit',
    icon: '',
  },
  BANK_TRANSFER: {
    id: 3,
    description: 'merchant_paid_method_bank_transfer',
    icon: '',
  },
  CYBER_SOURCE: {
    id: 4,
    description: 'merchant_paid_method_cyber_source',
    icon: '',
  },
  NAPAS: {
    id: 5,
    description: 'merchant_paid_method_napas',
    icon: '',
  },
  TOPPAY: {
    id: 6,
    description: 'merchant_paid_method_topay',
    icon: 'icon-merchant-wallet',
    title: 'rebranding.mod_transaction_wallet',
  },
  MOMO: {
    id: 7,
    description: 'merchant_paid_method_momo',
    icon: '',
  },
  VNPAY: {
    id: 8,
    description: 'merchant_paid_method_vn_pay',
    icon: '',
  },
  FDC: {
    id: 9,
    description: 'merchant_paid_method_fdc',
    icon: '',
  },
  PN_CREDIT_CODE: {
    id: 10,
    description: 'merchant_paid_method_pn_credit_code',
    icon: '',
  },
  SACOMBANK_ECOM: {
    id: 11,
    description: 'merchant_paid_method_sacombank_ecom',
    icon: '',
  },
};

export const EnumBookingNowShipStatus = {
  INIT: {
    id: 1,
    value: 1,
    label: 'nex_INIT',
    class: 'blue',
  },
  ASSIGNING: {
    id: 2,
    value: 2,
    label: 'nex_ASSIGNING',
    class: 'blue',
  },
  ASSIGNING_TIMEOUT: {
    id: 3,
    value: 3,
    label: 'nex_ASSIGNING_TIMEOUT',
    class: 'blue',
  },
  ASSIGNED: {
    id: 4,
    value: 4,
    label: 'nex_ASSIGNED',
    class: 'blue',
  },
  COMING: {
    id: 5,
    value: 5,
    label: 'nex_COMING',
    class: 'blue',
  },
  USER_CANCELED: {
    id: 6,
    value: 6,
    label: 'nex_USER_CANCELED',
    class: 'red',
  },
  ARRIVED: {
    id: 7,
    value: 7,
    label: 'nex_ARRIVED',
    class: 'blue',
  },
  PICKUP: {
    id: 8,
    value: 8,
    label: 'nex_PICKUP',
    class: 'blue',
    icon: 'fa-shopping-bag',
  },
  DRIVER_CANCELED: {
    id: 9,
    value: 9,
    label: 'nex_DRIVER_CANCELED',
    class: 'red',
  },
  IN_PROCESS: {
    id: 10,
    value: 10,
    label: 'nex_IN_PROCESS',
    class: 'blue',
  },
  COMPLETED: {
    id: 11,
    value: 11,
    label: 'nex_COMPLETED',
    class: 'green',
    icon: 'fa-check',
  },
  SYSTEM_CANCELED: {
    id: 12,
    value: 12,
    label: 'nex_SYSTEM_CANCELED',
    class: 'gray',
  },
  SYSTEM_ASSIGNED: {
    id: 13,
    value: 13,
    label: 'nex_SYSTEM_ASSIGNED',
    class: 'blue',
  },
  RETURN_SUCCESS: {
    id: 14,
    value: 14,
    label: 'nex_RETURN_SUCCESS',
    class: 'green',
  },
  RETURN_FAILED: {
    id: 15,
    value: 15,
    label: 'nex_RETURN_FAILED',
    class: 'red',
  },
  SCHEDULING: {
    id: 16,
    value: 16,
    label: 'nex_SCHEDULING',
    class: 'blue',
  },
};

export const EnumBookingNowShipStatusBrief = {
  IN_PROGRESS: {
    id: 1,
    value: 1,
    label: 'nex_processing',
  },
  COMPLETED: {
    id: 2,
    value: 2,
    label: 'nex_COMPLETED',
  },
};

export const EnumPaidStatusNowShip = {
  ERROR: {
    id: -1,
    description: 'ERROR',
  },
  INIT: {
    id: 1,
    description: 'INIT',
  },
  PAID: {
    id: 2,
    description: 'PAID',
    name: 'Paid',
  },
  PENDING: {
    id: 3,
    description: 'PENDING',
  },
  PENDING_AUTH: {
    id: 4,
    description: 'PENDING_AUTH',
  },
  FAILED: {
    id: 5,
    description: 'FAILED',
  },
  PENDING_REFUND: {
    id: 6,
    description: 'PENDING_REFUND',
  },
  PARTIAL_REFUNDED: {
    id: 7,
    description: 'PARTIAL_REFUNDED',
  },
  REFUNDED: {
    id: 8,
    description: 'REFUNDED',
  },
  REFUND_FAILED: {
    id: 9,
    description: 'REFUND_FAILED',
  },
  PREPAID_COD: {
    id: 10,
    description: 'PREPAID_COD',
  },
  RECHARGED_MERCHANT: {
    id: 11,
    description: 'RECHARGED_MERCHANT',
  },
  RECHARGED_MERCHANT_FAILED: {
    id: 12,
    description: 'RECHARGED_MERCHANT_FAILED',
  },
  PENDING_RECHARGE: {
    id: 11,
    description: 'PENDING_RECHARGE',
  },
};

export const EnumPaymentMethodNowShip = {
  COD: {
    id: 1,
    value: 1,
    label: 'COD',
  },
  PAYNOW_CREDIT: {
    id: 2,
    value: 2,
    label: 'PAYNOW_CREDIT',
  },
  BANK_TRANSFER: {
    id: 3,
    value: 3,
    label: 'BANK_TRANSFER',
  },
  CYBER_SOURCE: {
    id: 4,
    value: 4,
    label: 'CYBER_SOURCE',
  },
  NAPAS: {
    id: 5,
    value: 5,
    label: 'NAPAS',
  },
  TOPPAY: {
    id: 6,
    value: 6,
    label: 'TOPPAY',
  },
  MOMO: {
    id: 7,
    value: 7,
    label: 'MOMO',
  },
  VNPAY: {
    id: 8,
    value: 8,
    label: 'VNPAY',
  },
  FDC: {
    id: 9,
    value: 9,
    label: 'FDC',
  },
  PN_CREDIT_CODE: {
    id: 10,
    value: 10,
    label: 'PN_CREDIT_CODE',
  },
  SACOMBANK_ECOM: {
    id: 11,
    value: 11,
    label: 'SACOMBANK_ECOM',
  },
  AIRPAY_CREDIT_CARD: {
    id: 12,
    value: 12,
    label: 'AIRPAY_CREDIT_CARD',
  },
  NOW_PORTAL: {
    id: 13,
    value: 13,
    label: 'ShopeeFood_PORTAL',
  },
};

export const EnumBookingStatusNowShip = {
  INIT: {
    id: 1,
    description: 'INIT',
  },
  ASSIGNING: {
    id: 2,
    description: 'ASSIGNING',
  },
  ASSIGNING_TIMEOUT: {
    id: 3,
    description: 'ASSIGNING_TIMEOUT',
  },
  ASSIGNED: {
    id: 4,
    description: 'ASSIGNED',
  },
  COMING: {
    id: 5,
    description: 'COMING',
  },
  USER_CANCELED: {
    id: 6,
    description: 'USER_CANCELED',
  },
  ARRIVED: {
    id: 7,
    description: 'ARRIVED',
  },
  PICKUP: {
    id: 8,
    description: 'PICKUP',
  },
  DRIVER_CANCELED: {
    id: 9,
    description: 'DRIVER_CANCELED',
  },
  IN_PROCESS: {
    id: 10,
    description: 'IN_PROCESS',
  },
  COMPLETED: {
    id: 11,
    description: 'COMPLETED',
  },
  SYSTEM_CANCELED: {
    id: 12,
    description: 'SYSTEM_CANCELED',
  },
  SYSTEM_ASSIGNED: {
    id: 13,
    description: 'SYSTEM_ASSIGNED',
  },
  RETURN_SUCCESS: {
    id: 14,
    description: 'RETURN_SUCCESS',
  },
  RETURN_FAILED: {
    id: 15,
    description: 'RETURN_FAILED',
  },
  SCHEDULING: {
    id: 16,
    description: 'SCHEDULING',
  },
  RETURNING: {
    id: 17,
    description: 'RETURNING',
  },
};

export const EnumPayByTypeNowShip = {
  SENDER: {
    id: 0,
    value: 0,
    label: 'nex_merchant_pay',
  },
  RECEIVER: {
    id: 1,
    value: 1,
    label: 'nex_receive_pay',
  },
};

export const EnumBookingType = {
  MOTO: {
    id: 1,
    value: 1,
    label: 'Moto',
  },
  SHIPPING: {
    id: 2,
    value: 2,
    label: 'Shopee Express Instant',
  },
  SHIPPING_MERCHANT: {
    id: 3,
    value: 3,
    label: 'M_Shopee Express Instant',
  },
};

export const EnumPickTypeNowShip = {
  ASAP: {
    id: 1,
  },
  SCHEDULED: {
    id: 2,
  },
};

export const EnumOrderStatus = {
  DRAFT: {
    id: 1,
    message: 'mod_order_status_DRAFT',
  },
  RECEIVED: {
    id: 2,
    message: 'mod_order_status_RECEIVED',
  },
  PROCESSING: {
    id: 3,
    message: 'mod_order_status_PROCESSING',
  },
  VERIFIED: {
    id: 4,
    message: 'mod_order_status_VERIFIED',
  },
  ASSIGNED: {
    id: 5,
    message: 'mod_order_status_ASSIGNED',
  },
  PICKED: {
    id: 6,
    message: 'mod_order_status_PICKED',
  },
  DELIVERED: {
    id: 7,
    message: 'mod_order_status_DELIVERED',
  },
  CANCEL: {
    id: 8,
    message: 'rebranding.merchant_order_cancel_order',
  },
  QUIT: {
    id: 9,
    message: 'mod_order_status_QUIT',
  },
  REASSIGNED: {
    id: 10,
    message: 'mod_order_status_REASSIGNED',
  },
  INCHARGED: {
    id: 11,
    message: 'mod_order_status_INCHARGED',
  },
  DENIED: {
    id: 12,
    message: 'mod_order_status_DENIED',
  },
  CONFIRMED: {
    id: 13,
    message: 'rebranding.merchant_order_order_confirm_by_now',
  },
  M_ASSIGNED: {
    id: 14,
    message: 'merchant_order_you_have_new_order',
  },
  M_RECEIVED: {
    id: 15,
    message: 'mod_order_status_received',
  },
  M_TIMEOUT: {
    id: 16,
    message: 'mod_order_status_M_TIMEOUT',
  },
  M_OUTOFSERVICE: {
    id: 17,
    message: 'mod_order_status_M_OUTOFSERVICE',
  },
  M_COOKED: {
    id: 18,
    message: 'mod_order_status_M_COOKED',
  },
  M_CHANGED: {
    id: 19,
    message: 'mod_order_status_M_CHANGED',
  },
  CAN_NOT_CONNECT: {
    id: 20,
    message: 'mod_order_status_CAN_NOT_CONNECT',
  },
  AUTO_ASSIGN: {
    id: 21,
    message: 'mod_order_status_AUTO_ASSIGN',
  },
  AUTO_ASSIGN_TIMEOUT: {
    id: 22,
    message: 'mod_order_status_AUTO_ASSIGN_TIMEOUT',
  },
  PENDING: {
    id: 23,
    message: 'mod_order_status_PENDING',
  },
  REJECTED: {
    id: 24,
    message: 'mod_order_status_REJECTED',
  },
  FAILED: {
    id: 25,
    message: 'mod_order_status_FAILED',
  },
  CLOSE: {
    id: 26,
    message: 'mod_order_status_CLOSE',
  },
};

export const EnumNotificationBell = {
  ORDER: {
    to: '/order/order-management',
    id: 1,
    topic: RESTAURANT_MQTT_TOPIC,
    title: 'ShopeeFood',
    className: 'now',
    logo: MesLogoIcon
  },
  TABLE: {
    to: '/table/table-management',
    id: 2,
    topic: NOW_TABLE_MQTT_TOPIC,
    title: 'Table',
    className: 'table',
    logo: TableLogoIcon
  },
};

export const EnumShippingMethod = {
  STANDARD: {
    id: 1,
    description: 'merchant_shipping_method_standard',
  },
  PREMIER: {
    id: 2,
    description: 'merchant_shipping_method_premier',
  },
  PICKUP: {
    id: 3,
    description: 'merchant_shipping_method_pickup',
  },
};

export const EnumMerchantPaidStatus = {
  UN_PAID: 1,
  PAID: 2,
  FAIL: 3,
  REFUNDED: 4,
};

export const EnumTypeForm = {
  CREATE: {
    id: 1,
    description: 'CREATE',
  },
  UPDATE: {
    id: 2,
    description: 'UPDATE',
  },
};

export const EnumCommonStatus = {
  ACTIVE: {
    id: 1,
    description: 'ACTIVE',
  },
  INACTIVE: {
    id: 2,
    description: 'INACTIVE',
  },
};

export const EnumLocalStorage = {
  CURRENT_RESTAURANT: 'currentRestaurant',
};

export const EnumRatingNowShip = {
  HAPPY: {
    id: 1,
    class: 'happy',
    icon: 'fa-smile',
  },
  JUST_OK: {
    id: 2,
    class: 'normal',
    icon: 'fa-meh',
  },
  NOT_HAPPY: {
    id: 3,
    class: 'sad',
    icon: 'fa-frown',
  },
};

export const EnumPushTypeNowShip = {
  CHANGE_ORDER_STATUS: {
    id: 1,
  },
  CHAT: {
    id: 2,
  },
  SHIPPER_LOCATION: {
    id: 3,
  },
};

export const EnumDeliveryByType = {
  NOW: {
    id: 1,
  },
  MERCHANT: {
    id: 2,
  },
};

export const EnumOrderMerchantToolFilter = {
  ALL: {
    id: 1,
    value: 1,
    label: 'table_order_filter_status_all',
  },
  New: {
    id: 4,
    value: 4,
    label: 'merchant_order_group_status_processing',
  },
  CONFIRMED: {
    id: 2,
    value: 2,
    label: 'table_order_filter_status_confirmed',
  },
  ARRIVED: {
    id: 5,
    value: 5,
    label: 'arrived',
  },
  CANCELED: {
    id: 3,
    value: 3,
    label: 'table_order_filter_status_canceled',
  },
};

export const EnumTableOrderStatus = {
  RECEIVED: {
    id: 2,
    description: 'mtn_order_status_RECEIVED',
  },
  PROCESSING: {
    id: 3,
    description: 'mtn_order_status_PROCESSING',
  },
  VERIFIED: {
    id: 6,
    description: 'mtn_order_status_VERIFIED',
  },
  CANCELLED: {
    id: 4,
    description: 'mtn_order_status_CANCELLED',
  },
  CONFIRMED: {
    id: 7,
    description: 'mtn_order_status_CONFIRMED',
  },
  COMPLETED: {
    id: 5,
    description: 'mtn_order_status_COMPLETED',
  },
  ABSENT: {
    id: 8,
    description: 'mtn_order_status_ABSENT',
  },
  EDITED: {
    id: 9,
    description: 'mtn_order_status_EDITED',
  },
  CANCEL_BY_ADMIN: {
    id: 10,
    description: 'mtn_order_status_CANCEL_BY_ADMIN',
  },
  CANCEL_BY_USER: {
    id: 11,
    description: 'mtn_order_status_CANCEL_BY_USER',
  },
  ERROR: {
    id: 12,
    description: 'mtn_order_status_ERROR',
  },
  COMPLETED_BY_MERCHANT: {
    id: 13,
    description: 'mtn_order_status_COMPLETED_BY_MERCHANT',
  },
  NO_SHOW: {
    id: 14,
    description: 'mtn_order_status_NO_SHOW',
  },
  COMPLETED_BY_USER: {
    id: 15,
    description: 'mtn_order_status_COMPLETED_BY_USER',
  },
  ABSENT_BY_USER: {
    id: 16,
    description: 'mtn_order_status_ABSENT_BY_USER',
  },
  CANCEL_BY_MERCHANT: {
    id: 18,
    description: 'cancel_by_merchant',
  },
};

export const EnumToggleType = {
  ON: {
    id: 1,
  },
  OFF: {
    id: 0,
  },
};

export const EnumUserChatRole = {
  USER: {
    id: 1,
    description: 'nex_user',
    color: '#0117ff',
  },
  SHIPPER: {
    id: 2,
    description: 'nex_shipper',
    color: '#90949c',
  },
  CALL_CENTER: {
    id: 3,
    description: 'nex_cc',
    color: '#2e882b',
  },
};

export const EnumChatTabTypeNowShip = {
  SHIPPER_MERCHANT_CC: {
    id: 4,
    userRoles: [
      EnumUserChatRole.USER,
      EnumUserChatRole.SHIPPER,
      EnumUserChatRole.CALL_CENTER,
    ],
  },
};

export const EnumMqttChatPayloadTypeNowShip = {
  NEW_MESSAGE: {
    id: 1,
  },
  UPDATE_USER_SEEN_STATUS: {
    id: 2,
  },
  DELETE_MESSAGE: {
    id: 3,
  },
  EDIT_MESSAGE: {
    id: 4,
  },
};

export const EnumChatAppType = {
  NOW_FOOD: {
    id: 1,
    defaultChatTab: null,
    listChatTab: [],
    label: 'Food',
    icon: '',
  },
  NOW_SHIP: {
    id: 2,
    defaultChatTab: EnumChatTabTypeNowShip.SHIPPER_MERCHANT_CC.id,
    listChatTab: [EnumChatTabTypeNowShip.SHIPPER_MERCHANT_CC],
    label: 'Shopee Express Instant',
    icon: 'icon icon-now-ship',
  },
  TABLE_NOW: {
    id: 3,
    defaultChatTab: null,
    listChatTab: [],
    label: 'Table',
    icon: '',
  },
};

export const EnumMessageStatus = {
  READ: {
    id: 2,
  },
  UNREAD: {
    id: 1,
  },
};

export const EnumMerchantStaffRole = {
  MERCHANT_OWNER: {
    id: 1,
  },
  DELIVERY_MANAGER: {
    id: 2,
  },
  TABLE_NOW_MANAGER: {
    id: 3,
  },
  TABLE_NOW_STAFF: {
    id: 4,
  },
};

export const EnumActionMqtt = {
  ORDER: {
    id: 1,
    message: 'order',
  },
  MARK_SEEM: {
    id: 2,
    message: 'mark_seen',
  },
};

export const EnumPaymentMethod = {
  COD: {
    id: 1,
    message: 'COD',
  },
};

export const EnumDeliveryDiscountType = {
  PROMO_CODE: {
    id: 1,
  },
  FREESHIP: {
    id: 2,
  },
  FIRST_ORDER_MERCHANT: {
    id: 3,
  },
  FRAME_DISCOUNT: {
    id: 4,
  },
  ITEM_DISCOUNT: {
    id: 5,
  },
  REFERRAL: {
    id: 6,
  },
  AIRPAY_NEW_USER: {
    id: 7,
  },
  CASH_BACK: {
    id: 8,
  },
  SUBTOTAL_DISCOUNT: {
    id: 9,
  },
};

export const EnumTransactionType = {
  CASH_REMITTANCE: {
    id: 21018,
    description: 'Cash Remittance',
  },
  CREDIT_VIA_DIRECT_TOPUP: {
    id: 21019,
    description: 'Credit via direct topup',
  },
  PAYMENT_NOW_DELI_PAY: {
    id: 21020,
    description: 'Payment from ShopeeFood',
  },
  CASH_VIA_NOW_DELI_PAY: {
    id: 21021,
    description: 'Cash via ShopeeFood',
  },
  PAYMENT_NOW_DELI_REFUND: {
    id: 21022,
    description: 'Payment ShopeeFood Refund',
  },
  CREDIT_VIA_NOW_DELI_REFUND: {
    id: 21023,
    description: 'Credit via ShopeeFood Refund',
  },
  MANUAL_CASH_REMITTANCE: {
    id: 21024,
    description: 'Manual Cash Remittance',
  },
  PAYMENT_WALLET_CASH_TRANSFER_TO_WITHDRAWAL: {
    id: 21025,
    description: 'Payment wallet cash transfer to withdrawal',
  },
  CASH_VIA_WALLET_CASH_TRANSFER_TO_WITHDRAWAL: {
    id: 21026,
    description: 'Cash via wallet cash transfer to withdrawal',
  },
  WALLET_CASH_GIRO_WITHDRAWAL: {
    id: 21027,
    description: 'Wallet cash giro withdrawal',
  },
  CASH_GIRO_WITHDRAWAL: {
    id: 21028,
    description: 'Cash giro withdrawal',
  },
  WALLET_CASH_DIRECT_TOPUP: {
    id: 21029,
    description: 'Wallet cash direct topup',
  },
  CASH_VIA_DIRECT_TOPUP: {
    id: 21041,
    description: 'Cash via direct topup',
  },
  CASH_DIRECT_DEDUCT: {
    id: 21042,
    description: 'Cash direct deduct',
  },
  CREDIT_DIRECT_DEDUCT: {
    id: 21043,
    description: 'Credit direct deduct',
  },
  PAYMENT_NOW_DELI_CLAIM_COMMISSION: {
    id: 21044,
    description: 'Payment NowDelivery Claim Commission',
  },
  CREDIT_VIA_NOW_DELI_CLAIM_COMMISSION: {
    id: 21045,
    description: 'Credit via NowDelivery Claim Commission',
  },
  PAYMENT_NOW_DELI_RETURN_COMMISSION: {
    id: 21046,
    description: 'Payment NowDelivery Return Commission',
  },
  CASH_VIA_NOW_DELI_RETURN_COMMISSION: {
    id: 21047,
    description: 'Cash via NowDelivery Return Comission',
  },
  PAYMENT_NOW_SHIP_PAY_COD: {
    id: 21100,
    description: 'Payment Shopee Express Instant pay COD',
  },
  CASH_VIA_NOW_SHIP_PAY_COD: {
    id: 21101,
    description: 'Cash via Shopee Express Instant pay COD',
  },
  PAYMENT_NOW_SHIP_RECEIVE_COD: {
    id: 21102,
    description: 'Payment Shopee Express Instant receive COD',
  },
  CREDIT_VIA_NOW_SHIP_RECEIVE_COD: {
    id: 21103,
    description: 'Credit via Shopee Express Instant receive COD',
  },
  PAYMENT_NOW_SHIP_CLAIM_RETURN_FEE: {
    id: 21104,
    description: 'Payment Shopee Express Instant Claim Return Fee',
  },
  CREDIT_VIA_NOW_SHIP_CLAIM_RETURN_FEE: {
    id: 21105,
    description: 'Credit via Shopee Express Instant Claim Return Fee',
  },
  PAYMENT_NOW_SHIP_REFUND_RETURN_FEE: {
    id: 21106,
    description: 'Payment Shopee Express Instant Refund Return Fee',
  },
  CASH_VIA_NOW_SHIP_REFUND_RETURN_FEE: {
    id: 21107,
    description: 'Cash via Shopee Express Instant Refund Return Fee',
  },
};

export const EnumTransactionStatus = {
  SUCCESS: {
    id: 1,
    description: 'SUCCESS',
  },
  ON_HOLD: {
    id: 10,
    description: 'ON_HOLD',
  },
  FAIL: {
    id: 3,
    description: 'FAIL',
  },
  PENDING: {
    id: 2,
    description: 'PENDING',
  },
};

export const EnumBankAccountSource = {
  MERCHANT: {
    id: 1,
  },
  NOW: {
    id: 2,
  },
};

export const EnumMerchantPermission = {
  ORDER_ALL: {
    id: 1,
    message: 'ORDER_ALL',
  },
  REPORT_ALL: {
    id: 2,
    message: 'REPORT_ALL',
  },
  MENU_ALL: {
    id: 4,
    message: 'MENU_ALL',
  },
  EXPRESS_ALL: {
    id: 8,
    message: 'EXPRESS_ALL',
  },
  ACCOUNT_ALL: {
    id: 16,
    message: 'ACCOUNT_ALL',
  },
  PROMOTION_CREATE: {
    id: 32,
    message: 'PROMOTION_CREATE',
  },
  STAFF_MANAGEMENT: {
    id: 64,
    message: 'STAFF_MANAGEMENT',
  },
  PROMOTION_VIEW: {
    id: 128,
    message: 'PROMOTION_VIEW',
  },
  FEEDBACK_SYSTEM: {
    id: 256,
    message: 'FEEDBACK_SYSTEM',
  },
  FEEDBACK_SHIPPER: {
    id: 512,
    message: 'FEEDBACK_SHIPPER',
  },
  CUSTOMER_ALL: {
    id: 1024,
    message: 'CUSTOMER_ALL',
  },
  WALLET_ALL: {
    id: 2048,
    message: 'WALLET_ALL',
  },
};

export const EnumAirPayTransactionType = {
  PAY: {
    id: 1,
    message: 'PAY',
  },
  REFUND: {
    id: 2,
    message: 'REFUND',
  },
};

export const EnumReportType = {
  ORDER_REPORT: {
    id: 1,
    description: 'mod_report_type_ORDER_REPORT',
  },
};

export const EnumExportReportStatus = {
  PENDING: {
    id: 1,
    description: 'mod_report_status_PENDING',
    message: 'mod_export_restaurant_PENDING',
  },
  PROCESSING: {
    id: 2,
    description: 'mod_report_status_PROCESSING',
    message: 'mod_message_export_PROCESSING',
  },
  FAILED: {
    id: 3,
    description: 'mod_report_status_FAILED',
    message: 'mod_message_export_FAILED',
    color: 'text-danger',
  },
  SUCCESS: {
    id: 4,
    description: 'mod_report_status_SUCCESS',
    message: 'mod_message_export_SUCCESS',
    color: 'text-green',
  },
  EMPTY_DATA: {
    id: 5,
    description: 'mod_report_status_EMPTY_DATA',
    message: 'mod_message_export_EMPTY_DATA',
  },
};

export const EnumPartnerService = {
  NOW_FOOD: {
    id: 1,
    value: 1,
    label: 'ShopeeFood',
  },
  NOW_MARKET: {
    id: 2,
    value: 2,
    label: 'NowMarket',
  },
};

export const EnumTypePushMQTT = {
  MERCHANT_REPORT: {
    id: 1,
    value: 'merchant_report',
  },
};

export const EnumDisableStatusNowShip = [
  EnumBookingNowShipStatus.USER_CANCELED.id,
  EnumBookingNowShipStatus.DRIVER_CANCELED.id,
  EnumBookingNowShipStatus.SYSTEM_CANCELED.id,
  EnumBookingNowShipStatus.COMPLETED.id,
  EnumBookingNowShipStatus.RETURN_FAILED.id,
  EnumBookingNowShipStatus.RETURN_SUCCESS.id,
];

export const EnumMerchantStaffStatus = {
  ACTIVE: {
    id: 1,
    description: 'ACTIVE',
    label: 'set_staff_status_ACTIVE',
    class: 'text-green',
  },
  INACTIVE: {
    id: 2,
    description: 'INACTIVE',
    label: 'set_staff_status_INACTIVE',
    class: 'text-danger',
  },
  DELETED: {
    id: 3,
    description: 'DELETED',
    label: 'set_staff_status_DELETED',
  },
  PENDING: {
    id: 4,
    description: 'PENDING',
    label: 'set_staff_status_PENDING',
  },
};

export const EnumMerchantStaffRoleOrder = {
  MANAGER: {
    id: 1,
    value: 1,
    description: 'MANAGER',
    label: 'set_staff_role_MANAGER',
  },
  EMPLOYEE: {
    id: 2,
    value: 2,
    description: 'EMPLOYEE',
    label: 'set_staff_role_EMPLOYEE',
  },
  REPORTER: {
    id: 3,
    value: 3,
    description: 'REPORTER',
    label: 'set_staff_role_REPORTER',
  },
};

export const EnumLanguage = {
  VIETNAM: {
    id: 1,
    value: 'vi',
    icon: 'vn',
  },
  ENGLAND: {
    id: 2,
    value: 'en',
    icon: 'us',
  },
};

export const EndingBookingStatusNowShip = [
  EnumBookingNowShipStatus.USER_CANCELED.id,
  EnumBookingNowShipStatus.DRIVER_CANCELED.id,
  EnumBookingNowShipStatus.COMPLETED.id,
  EnumBookingNowShipStatus.SYSTEM_CANCELED.id,
  EnumBookingNowShipStatus.RETURN_SUCCESS.id,
  EnumBookingNowShipStatus.RETURN_FAILED.id,
];

export const EnumWalletServiceType = {
  ALL: {
    id: -1,
    value: -1,
    label: 'All',
  },
  NOW_FOOD: {
    id: 1,
    value: 1,
    label: 'ShopeeFood',
  },
  NOW_SHIP: {
    id: 2,
    value: 2,
    label: 'Shopee Express Instant',
  },
};

export const EnumBellSound = {
  NORMAL: {
    id: 1,
  },
  NOW_SHIP_ASSIGN_TIMEOUT: {
    id: 2,
  },
};

export const EnumOtherFeeType = {
  ORDER_BONUS: {
    id: 1,
  },
  PARKING_FEE: {
    id: 2,
  },
  HAND_DELIVERY_FEE: {
    id: 3,
  },
  PICK_PARKING_FEE: {
    id: 4,
    title: 'nex_packing_fee_sender',
  },
  DROP_PARKING_FEE: {
    id: 5,
    title: 'nex_packing_fee_receiver',
  },
  COMMISSION_FEE: {
    id: 6,
    title: 'nex_commission_fee',
  },
};

export const EnumCommissionFeeConfigType = {
  VALUE: {
    id: 1,
    label: 'Value',
  },
  PERMISSION: {
    id: 2,
    label: 'PERMISSION ',
  },
};

export const EnumTransferOrderStep = {
  SELECT_BRANCH: {
    id: 1,
    description: trans('transfer_order_to_another_branch'),
  },
  VERIFY_BRANCH: {
    id: 2,
    description: trans('verify_transfer_order_to_another_branch'),
  },
  TRANSFER_CONFIRM: {
    id: 3,
    description: trans('confirm_transfer_order_to_another_branch'),
  },
  TRANSFER_ERROR: {
    id: 4,
    description: trans('error_transfer_order_to_another_branch'),
  },
};

// export const EnumVerifyingTransferOrderState = {
//   VERIFYING: {
//     id: 1,
//     itemAndToppingLabel: trans('items_toppings_available'),
//     promotionLabel: trans('checking_for_promotions'),
//   },
//   VALID: {
//     id: 2,
//     itemAndToppingLabel: trans('items_toppings_available'),
//     promotionLabel: trans('able_to_apply_promotion'),
//   },
//   INVALID: {
//     id: 3,
//     itemAndToppingLabel: trans('some_items_are_not_listed'),
//     promotionLabel: trans('unable_to_apply_promotion'),
//   }
// };

export const EnumRestaurantOpenStatus = {
  BUSY: {
    id: 1,
    description: trans('restaurant_busy'),
    className: 'busy',
  },
  CLOSED: {
    id: 2,
    description: trans('restaurant_closed'),
    className: 'closed',
  },
  ONLINE: {
    id: -1,
    description: trans('restaurant_online'),
    className: 'online',
  },
};

export const EnumReportTimeFilterType = {
  SUBMITTED_TIME: {
    value: 1,
    label: trans('report_submitted_time'),
  },
  DELIVERED_TIME: {
    value: 2,
    label: trans('report_delivered_time'),
  },
};

export const EnumSortOrder = {
  ASC: { id: 1 },
  DESC: { id: 2 },
};

export const EnumOrderManagementSortField = {
  ORDER_CODE: { id: 1 },
  DELIVERY_TIME: { id: 2 },
  TOTAL: { id: 3 },
  STATUS: { id: 4 },
};

export const EnumReportRestaurantSortField = {
  RESTAURANT: { id: 1 },
  QUANTITY_ORDER: { id: 2 },
  TOTAL_AMOUNT_BEFORE_DISCOUNT: { id: 3 },
  MERCHANT_DISCOUNT: { id: 4 },
  COMMISSION: { id: 5 },
  TOTAL_AMOUNT: { id: 6 },
};

export const EnumReportDishSortField = {
  DISH: { id: 1 },
  QUANTITY: { id: 2 },
};



// WEBPACK FOOTER //
// ./foody/src/constants/enum.js